import { connect } from 'react-redux';
import PPAPIE from './PPAPIE';

import { getAnnualResults } from '../../selectors';
import { setSystemProduction } from '../../actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    aFixedCharge: state.utility.aFixedCharge,
});

const combinedActions = {
    setSystemProduction,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(PPAPIE);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/PPAPIE/index.js